import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import InfoWhiteIcon from "../../../../assets/icons/info-purple.svg";
import "./FreeSubscriptionInfoModal.less";

export type FreeSubscriptionInfoModalProps = {
  onClose: () => void;
};

const FreeSubscriptionInfoModal: React.FC<FreeSubscriptionInfoModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOverlayClick = () => {
    onClose?.();
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  const handleEditProfileClick = () => {
    onClose();
    navigate("/creator/editProfile");
  };

  return (
    <div className="free-subscription-info-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="free-subscription-info-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="free-subscription-info-bottom-modal-scrollable">
          <img src={InfoWhiteIcon} className="free-subscription-info-bottom-modal-icon" alt="Info" />

          <div className="free-subscription-info-section-title">{t("free-subscription-info-what-is-title")}</div>

          <div className="free-subscription-info-description">{t("free-subscription-info-what-is-description")}</div>

          <div className="free-subscription-info-section-title">{t("free-subscription-info-how-to-modify-title")}</div>

          <div className="free-subscription-info-description">
            {t("free-subscription-info-how-to-modify-description-part1")}{" "}
            <span className="free-subscription-info-link" onClick={handleEditProfileClick}>
              {t("free-subscription-info-edit-profile-link")}
            </span>{" "}
            {t("free-subscription-info-how-to-modify-description-part2")}
          </div>
        </div>

        <div className="free-subscription-info-bottom-modal-footer">
          <button className="free-subscription-info-bottom-modal-accept-button" onClick={onClose}>
            {t("i-understand")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeSubscriptionInfoModal;
